import type {
  DiscoveriesView,
  WorldSnapshot,
} from "@frontier/protocol/contracts";

/** Revealed caches remain private and belong to one run, including event-only runs. */
export function withDiscoveredLoot(
  world: WorldSnapshot | null,
  discoveries: DiscoveriesView | null,
  runId: string | undefined,
): WorldSnapshot | null {
  if (
    !world ||
    !discoveries ||
    discoveries.runId !== runId ||
    !discoveries.loot.length
  )
    return world;
  const publicIds = new Set(world.loot.map((loot) => loot.id));
  const revealed = discoveries.loot
    .filter((loot) => !publicIds.has(loot.id))
    .map((loot) => ({ ...loot, claimedBy: [] }));
  return revealed.length
    ? { ...world, loot: [...world.loot, ...revealed] }
    : world;
}
